import { SVG, SVGProps } from './svg'

export function IconHelp(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M12 2a10 10 0 100 20 10 10 0 000-20zm1 15.5c0 .3-.2.5-.5.5h-1a.5.5 0 01-.5-.5v-1c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v1zm.9-5.2c1.2-.4 2-1.5 2-2.7V9A2.9 2.9 0 0013 6.1h-2A2.9 2.9 0 008.1 9v.5c0 .3.2.5.5.5h.8c.3 0 .5-.2.5-.5V9c0-.6.5-1.1 1.1-1.1h2A1.1 1.1 0 0114.2 9v.6c0 .4-.3.9-.8 1l-1 .3c-.7.3-1.2 1-1.2 1.8v.8c0 .3.2.5.5.5h.7c.3 0 .5-.2.5-.5v-.8l.1-.1.9-.3z"
      />
    </SVG>
  )
}
